import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00769403"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "input-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "currency-symbol" }, "HK$", -1))
const _hoisted_6 = ["min"]
const _hoisted_7 = { class: "ion-text-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_auction_bid_list = _resolveComponent("auction-bid-list")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_header, {
      showCloseModal: true,
      title: _ctx.getLocalizedStr(_ctx.product, 'title', 'titleEn')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_chip, {
          class: "no-border",
          color: "success",
          slot: "end"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_icon, { icon: _ctx.person }, null, 8, ["icon"]),
            _createVNode(_component_ion_label, null, {
              default: _withCtx(() => [
                _createElementVNode("b", null, _toDisplayString(_ctx.onlineViewerCount.value), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_ion_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card, { class: "ion-text-center" }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.product.photoLink
                    }, null, 8, _hoisted_1),
                    _createVNode(_component_ion_card_header, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_subtitle, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('currentBid')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            (_ctx.product.auction.currentBid != null)
                              ? (_openBlock(), _createElementBlock("b", _hoisted_2, "HK$" + _toDisplayString(Number(_ctx.product.auction.currentBid).toLocaleString()), 1))
                              : (_openBlock(), _createElementBlock("b", _hoisted_3, "-"))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_subtitle, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getTimeDiffText(_ctx.product.auction.endTime, _ctx.currentTime)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("form", {
                          onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitBid()), ["prevent"]))
                        }, [
                          _createVNode(_component_ion_item, {
                            class: "quantity-input-item ion-no-padding",
                            lines: "none",
                            style: {"margin-bottom":"0"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                size: "large",
                                class: "qty-action-btn",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.decrementBidAmount()), ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    class: "icon-24",
                                    slot: "icon-only",
                                    icon: _ctx.remove
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _withDirectives(_createElementVNode("input", {
                                  class: "quantity-input",
                                  type: "number",
                                  min: _ctx.getMinBidAmount(),
                                  max: "9999999",
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bidAmount) = $event)),
                                  onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editingBidAmount = true)),
                                  onBlur: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.onFinishInputBidAmount($event)), ["stop"])),
                                  required: ""
                                }, null, 40, _hoisted_6), [
                                  [_vModelText, _ctx.bidAmount]
                                ])
                              ]),
                              _createVNode(_component_ion_button, {
                                size: "large",
                                class: "qty-action-btn",
                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.incrementBidAmount()), ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    class: "icon-24",
                                    slot: "icon-only",
                                    icon: _ctx.add
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createElementVNode("p", _hoisted_7, [
                            (_ctx.locale == 'zh')
                              ? (_openBlock(), _createElementBlock("small", _hoisted_8, "比現時叫價多了 HK$" + _toDisplayString(_ctx.getCurrentBidAmountDiff().toLocaleString()), 1))
                              : (_openBlock(), _createElementBlock("small", _hoisted_9, "HK$" + _toDisplayString(_ctx.getCurrentBidAmountDiff().toLocaleString()) + " more than the current bid", 1))
                          ], 512), [
                            [_vShow, _ctx.product.auction.currentBid]
                          ]),
                          _createVNode(_component_ion_button, {
                            color: "tertiary",
                            type: "submit",
                            expand: "block",
                            style: {"margin-top":"10px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('placeBid')), 1)
                            ]),
                            _: 1
                          })
                        ], 32)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, {
              "size-xs": "12",
              "size-md": "6"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, { class: "ion-text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('bidHistory')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_auction_bid_list, {
                      bids: _ctx.product.auction.bids,
                      userId: _ctx.userId
                    }, null, 8, ["bids", "userId"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _ctx.product.auction.bids.length > 0]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}